import { connectFela } from '../../dependencies';
import MembershipsListHeader from './MembershipsListHeader';
import * as styles from './MembershipsListHeader.styles';

export default connectFela(styles)(MembershipsListHeader);
